require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jacob-hawken.json") })
        }
      }, "path---blog-author-jacob-hawken");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jacob-hawken!./.cache/json/blog-author-jacob-hawken.json
// module id = 647
// module chunks = 231608221292675